/**
 * WizardStep1Nip — Krok 1: NIP podmiotu.
 *
 * Walidacja przejścia do kroku 2: NIP zapisany (callback onNipSaved).
 *
 * Props:
 *   - savedNip (string)
 *   - onCompleted (callback)  — wywoływane gdy NIP zapisany (markCompleted(1) + auto-next)
 */
import { useEffect } from "react";
import { CheckCircle, User } from "lucide-react";
import { NipForm } from "../components/NipForm";

export const WizardStep1Nip = ({ savedNip, onCompleted }) => {
  // Jeśli NIP już zapisany przed wejściem na ten krok → od razu oznacz jako completed
  useEffect(() => {
    if (savedNip && savedNip.replace(/[-\s]/g, "").length === 10) {
      if (onCompleted) onCompleted(savedNip);
    }
  }, [savedNip]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-6" data-testid="wizard-step1">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <User className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-[#0F1F3D]">Krok 1: Dane podmiotu</h2>
        </div>
        <p className="text-sm text-gray-600">
          Podaj NIP firmy, dla której będziesz pobierać faktury z KSeF.
          Numer musi mieć dokładnie 10 cyfr.
        </p>
      </div>

      <NipForm
        initialNip={savedNip}
        onSaved={(newNip) => {
          if (onCompleted) onCompleted(newNip);
        }}
      />

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-start gap-2">
        <CheckCircle className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="text-xs text-blue-700">
          <p className="font-medium">Środowisko: PRODUKCJA</p>
          <p className="mt-1">
            Aplikacja pracuje wyłącznie z produkcyjnym Krajowym Systemem e-Faktur (ksef.mf.gov.pl).
          </p>
        </div>
      </div>
    </div>
  );
};

export default WizardStep1Nip;
